<div id="ht">
    <div id="main-cnt">

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">
                        <!-- edit da qui... -->
                        <form (ngSubmit)="saveUser()" [formGroup]="userForm">
                            <div class="ion-justify-content-center ion-align-items-center text-center">
                                <app-file-picker lable="Seleziona Immagine Profilo"
                                        detail="" #imgProfilePicker buttonText="Scegli File"
                                        baseDirectory="profile/{{sessionService.user.id}}/"
                                        [s3Image]="currentUser?.profileImg"></app-file-picker>
                            </div>
                            <ion-label position="floating">Nome</ion-label>
                            <ion-input placeholder="Nome" class="text-input" formControlName="name"
                                       type="text"></ion-input>
                            <ion-label position="floating">Cognome</ion-label>

                            <ion-input placeholder="Cognome" class="text-input" formControlName="lastname"
                                       type="text"></ion-input>
                            <ion-label position="floating">Codice fiscale</ion-label>
                            <ion-input placeholder="Codice fiscale" class="text-input" formControlName="cf"
                                       type="text"></ion-input>
                            <ion-label position="floating">Numero C.I.</ion-label>
                            <ion-input placeholder="Numero C.I." class="text-input" formControlName="numeroCI"
                                       type="text"></ion-input>
                            <ion-label position="floating">Email</ion-label>
                            <ion-input placeholder="Email" class="text-input" formControlName="email"
                                       type="text"></ion-input>

                            <ion-label position="floating">Telefono</ion-label>
                            <ion-input placeholder="Telefono" class="text-input" formControlName="phoneNumber"
                                       type="text"></ion-input>


                            <ion-label>Role</ion-label>
                            <ion-select class="text-input"
                                        *ngIf="sessionService.user.permessions == permissionsType.ADMINISTRATOR"
                                        interface="action-sheet" placeholder="Select Role"
                                        formControlName="permessions">
                                <ion-select-option *ngFor="let role of permissionsType|keyvalue"
                                                   [value]="role.value">{{role.value}}</ion-select-option>
                            </ion-select>
                            <ion-label>Added By</ion-label>
                            <ion-select class="text-input" interface="action-sheet"
                                        placeholder="Leave empty to create a Team" formControlName="addedBy"
                                        [disabled]="sessionService.user.permessions !== sessionService.permissionType.ADMINISTRATOR">
                                <ion-select-option [value]="null"></ion-select-option>
                                <ion-select-option *ngFor="let advisor of advisors"
                                                   [value]="advisor.id">{{advisor.name |titlecase}} {{advisor.lastname|titlecase}}</ion-select-option>
                            </ion-select>

                            <ion-input placeholder="Wallet TRC20" class="text-input" formControlName="TRC20"
                                       type="text"></ion-input>
                            <ion-textarea placeholder="Notes" class="text-input" formControlName="notes"
                                          type="text"></ion-textarea>

                            <br>
                            <button expand="block" type="submit"
                                    class="button glass-blurred-background drop-shadow padding">{{ saveUserButtonText }}</button>
                        </form>

                        <!-- ...a qui -->
                    </div>
                </div>
            </div>
        </ion-content>

    </div>
</div>


<!--
<ion-header>
    <ion-toolbar>
        <div class="modal-top"></div>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding model-content">
    <form (ngSubmit)="saveUser()" [formGroup]="userForm">
        <ion-list class="inputLabel">
            <ion-item class="inputItem" detail="true">
                <ion-label class="addInput-Label"  color="primary" position="floating">Name</ion-label>
                <ion-input class="addInput" formControlName="name" type="text"></ion-input>
            </ion-item>
            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label"  color="primary" position="floating">Last Name</ion-label>
                <ion-input class="addInput" formControlName="lastname" type="text"></ion-input>
            </ion-item>
            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label"  color="primary" position="floating">Codice Fiscale</ion-label>
                <ion-input class="addInput" formControlName="cf" type="text"></ion-input>
            </ion-item>
            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label"  color="primary" position="floating">Numero C.I.</ion-label>
                <ion-input class="addInput" formControlName="numeroCI" type="text"></ion-input>
            </ion-item>
            <ion-item class="inputItem" detail="true">
                <ion-label class="addInput-Label"  color="primary" position="floating">Phone</ion-label>
                <ion-input class="addInput" formControlName="phoneNumber" maxlength="15" type="tel">
                </ion-input>
            </ion-item>
            <ion-item class="inputItem" detail="true" *ngIf="currentUser === null ">
                <ion-label class="addInput-Label"  color="primary" position="floating">Email</ion-label>
                <ion-input class="addInput" formControlName="email" type="email"></ion-input>
            </ion-item>
            <ion-item
                    *ngIf="sessionService.user.permessions == permissionsType.ADMINISTRATOR"
                    class="inputItem item-leave-height no-arrow" detail="false">
                <ion-label class="addInput-Label"  color="primary" position="floating">Ruolo</ion-label>
                <ion-select interface="action-sheet" placeholder="Select Role" formControlName="permessions"
                >
                    <ion-select-option *ngFor="let role of permissionsType|keyvalue"
                                       [value]="role.value">{{role.value}}</ion-select-option>
                </ion-select>
            </ion-item>
            <ion-item class="inputItem item-leave-height no-arrow" detail="false">
                <ion-label class="addInput-Label"  color="primary" position="floating">Added by (@todo autocomplete)</ion-label>
                <ion-select interface="action-sheet" placeholder="Leave empty to create a Team"
                            formControlName="addedBy"  [disabled]="sessionService.user.permessions !== sessionService.permissionType.ADMINISTRATOR">
                    <ion-select-option *ngFor="let advisor of advisors"
                                       [value]="advisor.id">{{advisor.name}} {{advisor.lastname}}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label" color="primary" position="floating">Wallet TRC20</ion-label>
                <ion-input class="addInput" formControlName="TRC20" type="text"></ion-input>
            </ion-item>

            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label"  color="primary" position="floating">Notes</ion-label>
                <ion-textarea class="addInput" formControlName="notes"></ion-textarea>
            </ion-item>
        </ion-list>
        <ion-button expand="block" type="submit" class="loginButton">{{ saveUserButtonText }}</ion-button>
    </form>
</ion-content> -->
